import { z } from "zod";
import { TObjectBase } from "../base";
import { TApiUserMetadata } from "../common/metadata";
import { TFirebaseTimestamp } from "../deprecated";

export type ICompanyInvoiceReceiverMetadata = z.infer<
  typeof TCompanyInvoiceReceiverMetadata
>;
export const TCompanyInvoiceReceiverMetadata = z.object({
  createdByUser: TApiUserMetadata.optional(),
  updatedByUser: TApiUserMetadata.optional(),
});

export type ICompanyInvoiceReceiver = z.infer<typeof TCompanyInvoiceReceiver>;
export const TCompanyInvoiceReceiver = z
  .object({
    address: z.string(),
    email: z.string(),
    postBox: z.string(),
    postalCode: z.string(),
    receiver: z.string(),
    reference: z.string().optional(),
    metadata: TCompanyInvoiceReceiverMetadata.optional(),
  })
  .extend(TObjectBase.shape);

export type IApiCompanyInvoiceReceiver = z.infer<
  typeof TApiCompanyInvoiceReceiver
>;
export const TApiCompanyInvoiceReceiver = TCompanyInvoiceReceiver.extend({
  companyID: z.string(),
});

export type IRawCompany = z.infer<typeof TRawCompany>;
export const TRawCompany = z
  .object({
    administrating: z.array(z.string()).optional(),
    administratedBy: z.array(z.string()).optional(),
    license: z.optional(
      z.enum(["customer", "administrated", "trial", "expired"])
    ),
    name: z.string().optional(),
    organizationId: z.string().optional(),
    organizationNumber: z.string().optional(), //Duplicate of organizationId
    trialEnd: TFirebaseTimestamp.nullish(),
    trialEndDate: TFirebaseTimestamp.nullish(),
    properties: z.array(z.string()).optional(),
    country: z.string().optional(),
    countryIso: z.string().optional(),
    timeZone: z.string().optional(),
  })
  .extend(TObjectBase.shape);

export type IRawCompanies = z.infer<typeof TRawCompanies>;
export const TRawCompanies = z.array(TRawCompany);
